module.exports = __webpack_public_path__ + "static/ramzy-6c6360df5727eec3e38d180a4059fa5b.jpg";